import React from 'react';
import Helmet from 'react-helmet';

import { IMGIX_URL } from '@src/env';

export enum TwitterCards {
  SummaryLargeImage = 'summary_large_image',
  Summary = 'summary',
}

const DEFAULT_TITLE = 'The Information';
const DEFAULT_IMAGE_PATH = `${IMGIX_URL}/global/defaults/article_image_unavailable.jpg`;

interface MetaTagsProps {
  title?: string;
  description?: string;
  ogImagePath?: string;
  ogDescription?: string;
  ogTitle?: string;
  twitterDescription?: string;
  twitterTitle?: string;
  twitterCard?: TwitterCards;
  ogSiteName?: string;
}

const MetaTags = ({
  title = DEFAULT_TITLE,
  description,
  ogImagePath = DEFAULT_IMAGE_PATH,
  ogDescription = description,
  ogTitle = title,
  ogSiteName = title,
  twitterDescription = description,
  twitterTitle = title,
  twitterCard = TwitterCards.SummaryLargeImage,
}: MetaTagsProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:site_name" content={ogSiteName} />
      <meta property="og:image" content={`${IMGIX_URL}${ogImagePath}`} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
    </Helmet>
  );
};

export default MetaTags;
